<!-- 纵向导航栏 -->
<style>
    .logo{
        width: 8rem; 
        z-index: 1000;
    }
    .arrow{
        border-radius: 50rem;
        overflow: hidden;
        box-shadow: inset 0 0 .15rem .1rem #fff;
    }
    .arrow-top,.arrow-bottom{
        transition: transform .15s linear;
    }
    .arrow:hover{
        border-radius: 0;
        overflow:unset;
        box-shadow: unset;
    }
    .arrow:hover .bi-house-fill{
        display: none !important;
    }
    .arrow:hover .bi-chevron{
        display: flex !important;
    }
    .arrow:hover .arrow-top{
        background: linear-gradient(0deg,#0d6efd,#9ec5ff);
        transform: skewX(-45deg);
        margin: 0 .25rem;
    }
    .arrow:hover .arrow-bottom{
        background: linear-gradient(180deg,#0d6efd,#0c3e88);
        transform: skewX(45deg);
        margin: 0 .25rem;
    }
    .bi-chevron>.bi-chevron-left::before{
        font-weight: bold !important;
        letter-spacing: -.25rem;
    }
    .bi-chevron>.bi-chevron-left{
        animation: change-color .9s linear infinite ;
    }
    @keyframes change-color {
        to{
            color: blue;
        }
    }
    .bi-chevron>.bi-chevron-left:nth-child(1){
        animation-delay: .6s;
    }
    .bi-chevron>.bi-chevron-left:nth-child(2){
        animation-delay: .3s;
    }
    .bi-chevron>.bi-chevron-left:nth-child(3){
        animation-delay: 0s;
    }
</style>
<template>
    <div class="d-flex flex-column">
        <div class="flex-grow-1 h-0 d-none d-sm-flex flex-column justify-content-center" style="flex-grow:.2 !important">
            <img class="logo mx-4 py-2" src="logo.png" alt="">
        </div>
        <div class="rounded-3 d-flex mx-2 p-1 flex-grow-1 h-0" style="flex-grow:.3 !important;background: repeating-linear-gradient(45deg, #0043ff, #0043ff 5%, #32c900 5%, #32c900 10%);">
            <div class="border-1 border-info border-dashed flex-grow-1 d-flex flex-column justify-content-evenly p-1 rounded" style="background: #0058a3;">

                <!-- 用户名 -->
                <div class="d-flex justify-content-between align-items-center bg-dark px-1 rounded-pill text-light mb-1 position-relative hover-tip">
                    <div>
                        <i class="bi bi-person-circle me-2 text-info"></i>
                        <span class="small">{{userInfo.id}}</span>
                    </div>
                    <i class="bi bi-box-arrow-right text-info hover-skyblue" @click="$root.logout" role="button"></i>
                    <div class="bg-dark bg-opacity-75 rounded-pill fs-_6rem py-1 px-2 position-absolute top-100 start-0 lh-1 w-100 tip-content d-none">{{userInfo.id}}</div>
                </div>
                <!-- 金币 -->
                <div v-if="!($route.name=='share'||gameModel==GAME_MODEL.tel)" class="d-flex justify-content-between align-items-center bg-dark px-1 rounded-pill text-light mb-1 position-relative hover-tip">
                    <div class="d-flex align-items-center">
                        <div class="rounded-circle bg-warning w-1rem h-1rem d-flex justify-content-center align-items-center text-primary me-2" style="background:linear-gradient(90deg, #6b6b00, yellow);box-shadow: -.1rem 0 0 #fff inset, 0 0 0 .1rem #d5d500 inset, .15rem 0 0 #999900, .2rem 0 0 #2a2a2a;transform: rotateY(15deg) rotateZ(15deg);">
                            <i class="bi bi-suit-spade-fill" style="color:#404000;transform: scale(.6);text-shadow: #000 .1rem 0 .1rem"></i>
                        </div>
                        <span class="align-middle small">{{userInfo.realCoin}}</span>
                    </div>
                    <i class="bi bi-plus-circle text-info hover-skyblue" @click="$root.setCurrModal($t('personal.recharge'))"></i>
                    <div class="bg-dark bg-opacity-75 rounded-pill fs-_6rem py-1 px-2 position-absolute top-100 start-0 lh-1 w-100 tip-content d-none">金币：玩家与平台博弈使用的积分</div>
                </div>
                <!-- 银币 -->
                <div v-if="!($route.name=='share'||gameModel==GAME_MODEL.tel)" class="d-flex justify-content-between align-items-center bg-dark px-1 rounded-pill text-light mb-1 position-relative hover-tip">
                    <div class="d-flex align-items-center">
                        <div class="rounded-circle bg-warning w-1rem h-1rem d-flex justify-content-center align-items-center text-primary me-2" style="background:linear-gradient(90deg, #56565f, #E6E6FA);box-shadow: -.1rem 0 0 #fff inset, 0 0 0 .1rem #bbbbc9 inset, .15rem 0 0 #8c8c99, .2rem 0 0 #2a2a2a;transform: rotateY(15deg) rotateZ(15deg);">
                            <i class="d-flex bi bi-suit-heart-fill" style="color:#db0000;transform: scale(.55);text-shadow: #830000 .1rem 0 .1rem"></i>
                        </div>
                        <span class="align-middle small">{{userInfo.esportsCoin}}</span>
                    </div>
                    <i class="bi bi-plus-circle text-info hover-skyblue" @click="$root.setCurrModal($t('personal.recharge'))"></i>
                    <div class="bg-dark bg-opacity-75 rounded-pill fs-_6rem py-1 px-2 position-absolute top-100 start-0 lh-1 w-100 tip-content d-none">银币：玩家与玩家竞技使用的积分</div>
                </div>
                <!-- 代券 -->
                <div v-if="IS_HAVE_TICKET||(userInfo.ticket&&userInfo.ticket.length)>0" class="d-flex justify-content-between align-items-center bg-dark px-1 rounded-pill text-light mb-1 position-relative hover-tip">
                    <div class="d-flex align-items-center">
                        <div class="rounded-_1rem w-1_2rem h-_8rem me-2 text-light small d-flex justify-content-end align-items-center" style="background: linear-gradient(0deg,#007dc9 20%, #ffa500 20%,#ffa500 40%, #007dc9 40%,#007dc9 60%, #ffa500 60%,#ffa500 80%, #007dc9 80% ) 29.35% .12rem/1px .64rem no-repeat,radial-gradient(circle at 30% 0, transparent .1rem, #ffa500 .1rem) 0 0/100% 55% no-repeat,radial-gradient(circle at 30% 100%, transparent .1rem, #ffa500 .1rem) 0 bottom/100% 50% no-repeat,linear-gradient(0deg,transparent,#fff,transparent);">
                            <span class="fs-_6rem lh-1 me-1 fw-bold">¥</span>
                        </div>
                        <span class="align-middle small">{{(userInfo.ticket&&userInfo.ticket.length)||0}}张</span>
                    </div>
                    <i v-if="userInfo.ticket&&userInfo.ticket.length>0" class="bi bi-eye text-info hover-skyblue" @click="$root.setCurrModal('我的代券')"></i>
                    <i v-else class="bi bi-eye-slash text-secondary"></i>
                    <div class="bg-dark bg-opacity-75 rounded-pill fs-_6rem py-1 px-2 position-absolute top-100 lh-1 text-nowrap tip-content d-none">代券：可代替金币/银币使用的券</div>
                </div>
                <!-- 按钮 -->
                <div class="d-flex justify-content-center small">
                    <button type="button" class="btn-shadow btn-success-1 border-0 px-2 small text-light fw-bold rounded-pill mx-1 py-0" @click="$root.setCurrModal($t('personal.recharge'))">{{$t('personal.recharge')}}</button>
                    <button type="button" class="btn-shadow btn-secondary-1 border-0 px-2 small text-light fw-bold rounded-pill mx-1 py-0" @click="$root.setCurrModal($t('personal.withdraw'))">{{$t('personal.withdraw')}}</button>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column flex-grow-1 h-0 justify-content-between">
            <div class="d-flex flex-column flex-grow-1 overflow-y-scroll px-2">
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setFullscreen">
                    <i class="bi bi-arrows-fullscreen me-1"></i>{{isFullscreen?$t("login.unFullscreen"):$t("login.fullscreen")}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.goPage('help',$root.callInfo,{id:userInfo.guid,name:userInfo.id,type:1,guid:guid})">
                    <i class="bi bi-chat-dots-fill me-1"></i>{{$t('common.onlineServices')}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setCurrModal($t('common.userRecords'))">
                    <i class="bi bi-journal-text me-1"></i>{{$t('common.userRecords')}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setCurrModal($t('personal.updateSource'))">
                    <i class="bi bi-piggy-bank me-1"></i>{{$t('personal.updateSource')}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setCurrModal($t('nav.network'))">
                    <i class="bi bi-hdd-network me-1"></i>{{$t('nav.network')}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setCurrModal($t('common.vipShare'))">
                    <i class="bi bi-people me-1"></i>{{$t('common.vipShare')}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setCurrModal($t('common.safeSetting'))">
                    <i class="bi bi-gear-fill me-1"></i>{{$t('common.safeSetting')}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setCurrModal($t('nav.sound'))">
                    <i class="bi bi-volume-up me-1"></i>{{$t('nav.sound')}}
                </span>
                <span class="btn btn-sm btn-navy rounded-5 text-light rounded-5 my-1" @click="$root.setCurrModal($t('common.questionFeedBack'))">
                    <i class="bi bi-question-circle me-1"></i>{{$t('common.questionFeedBack')}}
                </span>
            </div>

            <div class="d-flex justify-content-between small my-1 px-2">
                <!-- <div class="d-flex align-items-center text-light" @click="$root.logout">
                    <i class="bi bi-box-arrow-left d-flex me-1"></i>
                    <span>{{$t("common.exit")}}</span>
                </div>
                <div class="d-flex align-items-center text-light" @click="$root.goPage('home')">
                    <span>{{$t("nav.home")}}</span>
                    <i class="bi bi-house d-flex ms-1"></i>
                </div> -->
                <div class="text-light flex-grow-1 small position-relative arrow" @click="$root.goPage('home')">
                    <div class="h-_8rem arrow-top"></div>
                    <div class="h-_8rem arrow-bottom" ></div>
                    <div class="position-absolute start-0 top-0 bottom-0 end-0 d-flex justify-content-center align-items-center">
                        <i class="bi bi-house-fill d-flex me-2"></i>
                        <div class="d-none bi-chevron align-items-center me-2">
                            <i class="bi bi-chevron-left d-flex"></i>
                            <i class="bi bi-chevron-left d-flex"></i>
                            <i class="bi bi-chevron-left d-flex"></i>
                        </div>
                        <span>返回大厅</span>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    import { GAME_MODEL,IS_HAVE_TICKET } from "@/assets/js/config.js"
    export default{
        data() {
            return {
                GAME_MODEL,
                IS_HAVE_TICKET
            };
        },
        props:{
            isFullscreen:{
                type:Boolean,
                default:false
            },//当前是否全屏
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
            gameModel(){
                return this.$store.state.gameModel;
            }
        }
    }
</script>